import React from "react"
import PropTypes, { oneOfType } from "prop-types"
import Select from 'react-select'
import axios from 'axios';

class DistrictSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      districts: [],
      isMounted: false
    }
    this.districtSelected = this.districtSelected.bind(this)
  }

  componentDidMount() {
    let { districtId, provinceId } = this.props
    if (districtId) {
      this.getDistrictFromId(districtId)
    } else {
      if (provinceId) {
        this.getCollection()
      }
    }
  }

  setOptions(response) {
    let options = []
    response.data.map(e => {
      options.push({ id: e.id, text: e.name, value: e.id })
    })
    this.setState({
      districts: options,
      isMounted: true
    })
  }

  getDistrictFromId(districtId) {
    axios.get(`${process.env.REACT_APP_API_URL}/districts/${districtId}`)
    .then((response) => {
      let options = [{ id: response.data.id, text: response.data.name, value: response.data.id }]
      this.setState({
        districts: options,
        isMounted: true
      })
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  getCollection(query) {
    let params = {
      filter: {}
    }
    if (query) {
      params.filter.name = query
    }
    if (this.props.provinceId) {
      params.filter.province_id = this.props.provinceId
    }

    axios.get(`${process.env.REACT_APP_API_URL}/districts`, {
      params: params
    })
    .then((response) => {
      this.setOptions(response)
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
  }

  districtSelected(e) {
    let value = e.value
    if (value !== this.props.districtId && this.state.isMounted) {
      this.props.onChange(value, e)
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select
          className="select2-style"
          onChange={this.districtSelected}
          getOptionLabel={option =>
            `${option.text}`
          }
          value={this.state.districts.filter(option => option.value === this.props.districtId)}
          getOptionValue={option => `${option.id}`}
          options={this.state.districts}
          isDisabled={this.props.disabled}
          placeholder={'ค้นหา...'}
        />
      </React.Fragment>
    );
  }
}

DistrictSelect.propTypes = {
  districtId: oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  provinceId: oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default DistrictSelect
